import storeModule from '../store-module'
import { defineStore } from 'pinia'

const url = 'settings/contact-links'

export default defineStore(
  'contact-links',
  storeModule.createStoreModule('contact-links', {
    fetchSingleURL: url,
    updateURL: url
  })
)
